export const ArrowUp = (props) => {
  const { size = 16, onClick, verticalAlign, marginLeft, marginRight, top, color, className = '' } = props;
  return (
    <span onClick={onClick} className={`icon-wrap ${className}`} style={{ marginLeft, marginRight, top, color }}>
      <svg xmlns='http://www.w3.org/2000/svg' style={{ verticalAlign }} width={size} height={size} fill='none' viewBox='0 0 16 16'>
        <path
          stroke='currentColor'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='1.5'
          d='M8 12.666V3.333m0 0L3.333 8M8 3.333L12.666 8'
        ></path>
      </svg>
    </span>
  );
};
